import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { WebcontentsPresignedStorageResource } from '@libs/generated-types/webcontents';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { FeedService } from '../services/feed.service';
import { WebcontentService } from '../services/webcontent.service';


@Injectable({
  providedIn: 'root',
})
export class AttachmentsGuard implements CanActivate {
  loggedInStatus: boolean = false;
  constructor(private router: Router, private webContentsService: WebcontentService, private feedService: FeedService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    const fileKey = next.queryParams['fileKey'];
    const fileName = next.queryParams['fileName'];
    // const result: WebcontentsPresignedStorageResource = await firstValueFrom(this.webContentsService.downloadAttachment(fileKey));

    let media: WebcontentsPresignedStorageResource | null = null;
    const result = await this.webContentsService.validateTokenAndGetMediaById(fileKey, token!);
    this.loggedInStatus = result.valid;
    media = await result.media;

    if (this.loggedInStatus && media) {
      this.router.navigate(['/attachments', media?.presignedUrl, fileName]);
    } else {
      this.router.navigate(['/auth/login']);
    }

    return true;
  }
}
